import split from "servicestack/tags/pagination/tag-pagination-split.htm";
import stacked from "servicestack/tags/pagination/tag-pagination-stacked.htm";

export default {
  split,
  stacked,
};
